import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import DeliveryRow from '../Sales/Delivering/RowItem';
import OutstandingRow from '../Sales/Outstanding/RowItem';
import QualityControlRow from '../Sales/QualityControl/RowItem';
import FollowUpRow from '../Sales/FollowUp/TblRow/RowItem';
import NeedRefundRow from '../Sales/Failed/failedSaleList/RowItem';
import { returnQueueActions, isReturnRelisted, readSaleReturn, returnCourierLabel } from './returnSale';
import ReturnStatus from './ReturnStatus';

const listingPrice = (userSell) => (
  userSell.asking_price != null ? userSell.asking_price : null
);

const ReturnRow = ({
  rowId,
  sale,
  queue,
  onOpenAction,
  onOpenCreditCard,
  loginId,
}) => {
  const offer = sale.offer || {};
  const userSell = offer.user_sell || {};
  const product = sale.sale_product || {};
  const size = product.size || {};
  const { data: returnData } = readSaleReturn(sale);
  const shipment = returnData.shipment || {};
  const actions = returnQueueActions(queue, sale);
  const paymentMethod = offer.payment_method;
  const paymentVia = offer.payment_via;

  const SalesRow = queue === 'follow_up' ? FollowUpRow
    : queue === 'refund' ? NeedRefundRow
    : queue === 'qc' ? QualityControlRow
    : queue === 'outstanding' || queue === 'relisting' ? OutstandingRow
    : DeliveryRow;
  return (
    <SalesRow
      rowId={rowId}
      number={rowId}
      dataItem={{ ...sale, offer: { ...offer, user_sell: userSell } }}
      status={sale.status}
      selectedId={null}
      data={{ ...sale, offer: { ...offer, user_sell: userSell } }}
      id={sale.id}
      quantity={offer.quantity}
      buyerEmail={sale.buyer_email}
      invoiceNumber={sale.invoice_number}
      orderDate={sale.created_at}
      updatedAt={sale.updated_at}
      orderStatus={sale.status}
      totalAmount={sale.total_price == null ? 0 : sale.total_price}
      displayName={product.display_name}
      SKU={product.SKU}
      colour={product.colour}
      preOrder={product.pre_order}
      preVerified={product.pre_verified}
      isVintage={sale.is_vintage}
      legitCheckLogs={[]}
      purchasePrice={sale.purchase_price}
      consignmentId={product.consignment_id}
      sneakersCondition={product.sneakers_condition}
      category={product.category_name}
      size={size.US}
      bank={offer.bank_code}
      paymentVia={paymentVia}
      paymentMethod={paymentMethod}
      onOpenCreditCard={onOpenCreditCard}
      marked={sale.marked}
      notes={sale.sale_notes}
      loginId={loginId}
      markedAt={sale.open_marked_at}
      markedBy={sale.open_marked_by}
      closeMarkedAt={sale.close_marked_at}
      unreadNoteCount={sale.unread_notes_count}
      rack={userSell.rack}
      voucherCode={sale.voucher_code || (sale.voucherable && sale.voucherable.code) || sale.voucherable_id}
      returnDetails={{
        sellId: userSell.id,
        listingPrice: listingPrice(userSell),
        status: <>
          <ReturnStatus sale={sale} />
          {queue === 'follow_up' && returnData.follow_up_reason && <div style={{fontSize: '.75rem'}}>Reason: {returnData.follow_up_reason}</div>}
        </>,
        shipment: queue === 'delivering' && shipment.awb_number ? <div style={{fontSize: '.75rem'}}><strong>COURIER:</strong> {returnCourierLabel(shipment.courier)}<br /><strong>AWB:</strong> {shipment.awb_number}</div> : null,
        qc: returnData.qc_at ? {
          at: returnData.qc_at,
          by: returnData.qc_by_email || (returnData.qc_by != null ? `Admin #${returnData.qc_by}` : null),
        } : null,
        actions: (
          <div className="btn-group">
            {queue === 'refund' && <Link className="btn btn-sm btn-secondary" to={`/sales/${sale.id}`} title="Detail">
              <i className="fa fa-external-link"></i>
            </Link>}
            {queue === 'outstanding' ? (
              <Button color="primary" size="sm" onClick={() => onOpenAction(sale, 'receipt')}>
                Receive From Buyer
              </Button>
            ) : queue === 'qc' ? (
              <>
                <Button color="success" size="sm" title="Accept" onClick={() => onOpenAction(sale, 'pass')}>
                  <i className="fa fa-check"></i>
                </Button>
                <Button color="danger" size="sm" title="Reject" onClick={() => onOpenAction(sale, 'fail')}>
                  <i className="fa fa-times"></i>
                </Button>
              </>
            ) : actions.filter((action) => (
              (action.kind !== 'relist' || !isReturnRelisted(sale))
              && (action.kind !== 'refund' || !returnData.refunded_at)
            )).map((action) => (
              <Button key={action.kind} color={action.kind === 'buyer_reject' ? 'danger' : action.kind === 'buyer_approve' ? 'success' : 'primary'} size="sm" title={action.label} aria-label={action.label} onClick={() => onOpenAction(sale, action.kind)}>
                {action.kind === 'shipment' || action.kind === 'pickup' ? <><i className="fa fa-truck"></i> {action.kind === 'pickup' ? 'Confirm Pickup' : 'Pilih Courier'}</> : queue === 'follow_up' ? <><i className={action.kind === 'buyer_approve' ? 'fa fa-check' : 'fa fa-times'}></i> {action.label}</> : queue === 'refund' ? <i className="fa fa-cc"></i> : action.label}
              </Button>
            ))}
            {queue !== 'refund' && <Link className="btn btn-sm btn-secondary" to={`/sales/${sale.id}`} title="More Detail...">
              <i className="fa fa-external-link"></i>{queue === 'follow_up' ? ' Details' : null}
            </Link>}
          </div>
        ),
      }}
    />
  );
};

ReturnRow.propTypes = {
  rowId: propTypes.number.isRequired,
  sale: propTypes.object.isRequired,
  queue: propTypes.string,
  onOpenAction: propTypes.func.isRequired,
  onOpenCreditCard: propTypes.func.isRequired,
  loginId: propTypes.number,
};

ReturnRow.defaultProps = {
  queue: null,
};

export default ReturnRow;
